import { useRouter } from 'next/router';
import { OPEN_EXTEND_CONSTRACT_POLICY_SAVE_KEY } from '@/dashboard/constants/storeKey';
import { usePageJump } from '@/dashboard/hooks/usePageJump';
import { useProjectNavigate } from '@/dashboard/hooks/useProjectNavigate';
import { NotificationModelProps } from '@/dashboard/models/settings/NotificationModel';
import { usePolicyDetailStore } from '@/dashboard/store/PolicyDetailStore';
import { getRenewPolicyPath } from '@/dashboard/utils/routes';
import { getHomePolicysPath } from '@/dashboard/utils/routes';

export const useNotificationEvent = (model: NotificationModelProps) => {
  const {
    context: { key },
  } = model;
  const router = useRouter();
  const [{ cleanAllPolicyDetailInfo }] = usePolicyDetailStore((store) => [store.actions]);
  const { jumpToHomePage } = usePageJump();
  const { push } = useProjectNavigate();

  // renew
  const jumpRenewPolicy = () => {
    cleanAllPolicyDetailInfo();
    push({ path: getRenewPolicyPath(key) });
  };

  // extend contract policy
  // Do this temporarily, reuse the homepage policy logic
  const jumpExtendPolicy = () => {
    sessionStorage.setItem(OPEN_EXTEND_CONSTRACT_POLICY_SAVE_KEY, key);

    if (router.pathname === getHomePolicysPath()) {
      window.location.reload();
    } else {
      jumpToHomePage();
    }
  };

  // jump url
  const jumpUrl = () => {
    window.open(key);
  };

  return { jumpRenewPolicy, jumpExtendPolicy, jumpUrl };
};
